module.exports = __webpack_public_path__ + "img/code.e3d3f5c7.jpg";